<ng-container *ngIf="displayValidations">
    <ng-container *ngIf="validationSummary?.hasValidationErrors">
        <div class="alert alert-danger border-danger default-font-size" role="alert">
            <ng-container *ngFor="let validationError of validationSummary.validationErrors">
                {{getTranslatedError(validationError)}}
                <br>
            </ng-container>
        </div>
    </ng-container>
</ng-container>